import EndPoint from 'Api/EndPoint';
import Client from 'Api/Client';

const endpoint = `${EndPoint.Host}/${EndPoint.User}`;

export async function getStaffList(data) {
  return await Client.get(`${endpoint}/staff`, data, true);
}

export async function getStaffDetail(id) {
  return await Client.get(`${endpoint}/staff/${id}`, {}, true);
}

export async function createStaff(data) {
  return await Client.post(`${endpoint}/staff`, data, true);
}

export async function modifyStaff(id, data) {
  return await Client.put(`${endpoint}/staff/${id}`, data, true);
}

export async function changeStaffPassword(id, data) {
  return await Client.put(`${endpoint}/staff/${id}/password`, data, true);
}

export async function getFieldList(data) {
  return await Client.get(`${endpoint}/field`, data, true);
}

// 현장관리 > 모든현장(대시보드용)
export async function getFieldAllList(data) {
  return await Client.get(`${endpoint}/field/allList`, data, true);
}

export async function getFieldDetail(id) {
  return await Client.get(`${endpoint}/field/${id}`, {}, true);
}

export async function createField(data) {
  return await Client.post(`${endpoint}/field`, data, true);
}

export async function modifyField(data) {
  return await Client.put(`${endpoint}/field`, data, true);
}

export async function updateFieldStaff(data) {
  return await Client.put(`${endpoint}/field/staffs`, data, true);
}

export async function createFieldBudget(id, data) {
  return await Client.post(`${endpoint}/field/${id}/budget`, data, true);
}

export async function updateFieldBudget(fieldId, budgetId, data) {
  return await Client.put(`${endpoint}/field/${fieldId}/budget/${budgetId}`, data, true);
}

export async function deleteFieldBudget(id, data) {
  return await Client.delete(`${endpoint}/field/${id}/budget`, data, true);
}

export async function userFavorite(data) {
  return await Client.get(`${endpoint}/favorites`, data, true);
}

export async function updateUserFavorite(data) {
  return await Client.put(`${endpoint}/favorites`, data, true);
}

export async function postFieldDoc(fieldId, data) {
  return await Client.post(`${endpoint}/field/${fieldId}/doc`, data, true);
}

export async function putFieldDoc(fieldId, docId, data) {
  return await Client.put(`${endpoint}/field/${fieldId}/doc/${docId}`, data, true);
}

export async function deleteFieldDoc(fieldId, docId) {
  return await Client.delete(`${endpoint}/field/${fieldId}/doc/${docId}`, {}, true);
}

export async function uploadFieldDocImage(fieldId, image, onProgress = null) {
  return await Client.uploadFile(`${endpoint}/field/${fieldId}/doc/image`, 'image', image, onProgress);
}

export async function postFieldWorkLog(fieldId, data) {
  return await Client.post(`${endpoint}/field/${fieldId}/workLog`, data, true);
}

export async function putFieldWorkLog(fieldId, workLogId, data) {
  return await Client.put(`${endpoint}/field/${fieldId}/workLog/${workLogId}`, data, true);
}

export async function deleteFieldWorkLog(fieldId, workLogId) {
  return await Client.delete(`${endpoint}/field/${fieldId}/workLog/${workLogId}`, {}, true);
}

export async function uploadFieldWorkLogImage(fieldId, image, onProgress = null) {
  return await Client.uploadFile(`${endpoint}/field/${fieldId}/workLog/image`, 'image', image, onProgress);
}

export async function postFieldWorkLogComment(fieldId, workLogId, data) {
  return await Client.post(`${endpoint}/field/${fieldId}/workLog/${workLogId}/comment`, data, true);
}

export async function postFieldComment(fieldId, data) {
  return await Client.post(`${endpoint}/field/${fieldId}/comments`, data, true);
}

export async function putFieldComment(fieldId, commentId, data) {
  return await Client.put(`${endpoint}/field/${fieldId}/comments/${commentId}`, data, true);
}

export async function uploadFieldCommentImage(fieldId, image, onProgress = null) {
  return await Client.uploadFile(`${endpoint}/field/${fieldId}/comments/image`, 'image', image, onProgress);
}

export async function putFieldCommentNoNoty(fieldId, data) {
  return await Client.put(`${endpoint}/field/${fieldId}/comments/noNoty`, data, true);
}

export async function getFieldSchedule(data) {
  return await Client.get(`${endpoint}/field/schedule`, data, true);
}

export async function postFieldSchedule(fieldId, data) {
  return await Client.post(`${endpoint}/field/${fieldId}/schedule`, data, true);
}

export async function putFieldSchedule(fieldId, scheduleId, data) {
  return await Client.put(`${endpoint}/field/${fieldId}/schedule/${scheduleId}`, data, true);
}

export async function deleteFieldSchedule(fieldId, scheduleId) {
  return await Client.delete(`${endpoint}/field/${fieldId}/schedule/${scheduleId}`, {}, true);
}

export async function getFieldWorkLogFilters(id) {
  return await Client.get(`${endpoint}/field/${id}/workLog/filters`, {}, true);
}

export async function getFieldWorkLog(id, data) {
  return await Client.get(`${endpoint}/field/${id}/workLog`, data, true);
}

// 현장관리 > 현장보고 > 상세
export async function getWorkLogDetail(fieldId, workLogId) {
  return await Client.get(`${endpoint}/field/${fieldId}/workLog/${workLogId}`, {}, true);
}

export async function getFieldWorkLogDetail(id, data) {
  return await Client.get(`${endpoint}/field/${id}/workLogDetail`, data, true);
}

export async function getFieldWorkLogDetailStatusTypes(id) {
  return await Client.get(`${endpoint}/field/${id}/workLogDetail/statusTypes`, {}, true);
}

export async function putFieldWorkLogDetailWV(id, data) {
  return await Client.put(`${endpoint}/field/${id}/workLogDetail/workLogDetailWV`, data, true);
}

export async function getFieldWorkLogDetailDetail(fieldId, logId) {
  return await Client.get(`${endpoint}/field/${fieldId}/workLogDetail/${logId}`, {}, true);
}

export async function postFieldWorkLogDetail(fieldId, data) {
  return await Client.post(`${endpoint}/field/${fieldId}/workLogDetail`, data, true);
}

export async function putFieldWorkLogDetail(fieldId, logId, data) {
  return await Client.put(`${endpoint}/field/${fieldId}/workLogDetail/${logId}`, data, true);
}

export async function deleteFieldWorkLogDetail(fieldId, logId) {
  return await Client.delete(`${endpoint}/field/${fieldId}/workLogDetail/${logId}`, {}, true);
}

export async function downLoadFileFieldWorkLogDetailPng(fieldId, logId, fileName) {
  return await Client.downLoadFile(`${endpoint}/field/${fieldId}/workLogDetail/${logId}/webview/exportToPng`, {}, true, fileName);
}

export async function downLoadFileFieldWorkLogDetailPdf(fieldId, logId, fileName) {
  return await Client.downLoadFile(`${endpoint}/field/${fieldId}/workLogDetail/${logId}/webview/exportToPdf`, {}, true, fileName);
}

export async function uploadFileFieldWorkLogDetailImage(fieldId, image, onProgress = null) {
  return await Client.uploadFile(`${endpoint}/field/${fieldId}/workLogDetail/image`, 'image', image, onProgress);
}

export async function getFieldWorkLogDetailGetOrders(fieldId) {
  return await Client.get(`${endpoint}/field/${fieldId}/workLogDetail/getOrders`, {}, true);
}

export async function getFieldCommentUsers(fieldId, data) {
  return await Client.get(`${endpoint}/field/${fieldId}/comments/users`, data, true);
}

export async function getFieldComment(fieldId, data) {
  return await Client.get(`${endpoint}/field/${fieldId}/comments`, data, true);
}

export async function getFieldBudget(fieldId) {
  return await Client.get(`${endpoint}/field/${fieldId}/budget`, {}, true);
}

export async function putFieldWorkLogDetailIsConfirmed(fieldId, logId, data) {
  return await Client.put(`${endpoint}/field/${fieldId}/workLogDetail/${logId}/isConfirmed`, data, true);
}

// 회의록
// 리스트
export async function getFieldMinutesOfMeeting(fieldId, data) {
  return await Client.get(`${endpoint}/field/${fieldId}/minutesOfMeeting`, data, true);
}
// 상세
export async function getFieldMinutesOfMeetingDetail(fieldId, itemId) {
  return await Client.get(`${endpoint}/field/${fieldId}/minutesOfMeeting/${itemId}`, {}, true);
}
// 참여자 목록
export async function getFieldMinutesOfMeetingParticipants(fieldId) {
  return await Client.get(`${endpoint}/field/${fieldId}/minutesOfMeeting/participants`, {}, true);
}
// 생성
export async function postFieldMinutesOfMeeting(fieldId, data) {
  return await Client.post(`${endpoint}/field/${fieldId}/minutesOfMeeting`, data, true);
}
// 수정
export async function putFieldMinutesOfMeeting(fieldId, momId, data) {
  return await Client.put(`${endpoint}/field/${fieldId}/minutesOfMeeting/${momId}`, data, true);
}
// 삭제
export async function deleteFieldMinutesOfMeeting(fieldId, momId) {
  return await Client.delete(`${endpoint}/field/${fieldId}/minutesOfMeeting/${momId}`, {}, true);
}
// 이미지 업로드
export async function uploadFileMinutesOfMeeting(fieldId, image, onProgress = null) {
  return await Client.uploadFileWithoutCompress(`${endpoint}/field/${fieldId}/minutesOfMeeting/image`, 'image', image, onProgress);
}

// 현장예산
// 예산 추가 요청
export async function postFieldBudgetRequest(fieldId, data) {
  return await Client.post(`${endpoint}/field/${fieldId}/budget/request`, data, true);
}
// 예산 추가 요청 리스트
export async function getFieldBudgetRequest(fieldId) {
  return await Client.get(`${endpoint}/field/${fieldId}/budget/request`, {}, true);
}

// 예산 추가 요청 상세
export async function getFieldBudgetRequestDetail(fieldId, requestId) {
  return await Client.get(`${endpoint}/field/${fieldId}/budget/request/${requestId}`, {}, true);
}

// 전자계약
// 검색
export async function getFieldEContract(fieldId, data) {
  return await Client.get(`${endpoint}/field/${fieldId}/eContract`, data, true);
}
// 상세
export async function getFieldEContractDetail(fieldId, eContractId) {
  return await Client.get(`${endpoint}/field/${fieldId}/eContract/${eContractId}`, {}, true);
}
// 첨부파일 업로드 (<=10MB)
export async function uploadFieldEContractAttachment(fieldId, image, onProgress = null) {
  return await Client.uploadFileWithoutCompress(`${endpoint}/field/${fieldId}/eContract/attachment`, 'image', image, onProgress);
}
// 계약서 수정
export async function putFieldEContract(fieldId, eContractId, data) {
  return await Client.put(`${endpoint}/field/${fieldId}/eContract/${eContractId}`, data, true);
}
// 새 계약서 작성
export async function postFieldEContract(fieldId, data) {
  return await Client.post(`${endpoint}/field/${fieldId}/eContract`, data, true);
}
// 1[발행전] 미리보기
export async function getFieldEContractPreview(fieldId, eContractId) {
  return await Client.get(`${endpoint}/field/${fieldId}/eContract/${eContractId}/preview`, {}, true);
}
// 2[발행전] 계약서 발행하기
export async function postFieldEcontractModuSign(fieldId, eContractId) {
  return await Client.post(`${endpoint}/field/${fieldId}/eContract/${eContractId}/moduSign`, {}, true);
}
// 3[발행후] 서명 요청 알림 재전송
export async function postFieldEcontractRemindSigning(fieldId, eContractId) {
  return await Client.post(`${endpoint}/field/${fieldId}/eContract/${eContractId}/remindSigning`, {}, true);
}
// 4-2[발행후+서명후] 임베디드 url 조회
export async function getFieldEContractEmbeddedView(fieldId, eContractId) {
  return await Client.get(`${endpoint}/field/${fieldId}/eContract/${eContractId}/embeddedView`, {}, true);
}

// 현장관리 > 기본 정보 > 기본현장
export async function putFieldDefault(fieldId) {
  return await Client.put(`${endpoint}/field/${fieldId}/defaultField`, {}, true);
}

// 알림 > 알림 안 읽은 count
export async function getNotyCount() {
  return await Client.get(`${endpoint}/noty/count`, {}, true);
}

// 알림 > 알림 조회
export async function getNoty(data) {
  return await Client.get(`${endpoint}/noty`, data, true);
}

// 알림 > 알림 읽음처리
export async function postNoty(id) {
  return await Client.post(`${endpoint}/noty/${id}`, {}, true);
}

// 알림 > 알림 읽음처리 All
export async function putNotyAll() {
  return await Client.put(`${endpoint}/noty/all`, {}, true);
}

// 현장관리 > 기본정보 > 현장 사용함 On/Off
export async function patchFieldActive(data) {
  return await Client.patch(`${endpoint}/field/active`, data, true);
}

// 알림 > New 현장
export async function getNotyNew() {
  return await Client.get(`${endpoint}/noty/new`, {}, true);
}

// 알림 > New 현장메뉴
export async function getNotyNewMenu(id) {
  return await Client.get(`${endpoint}/noty/new/${id}`, {}, true);
}
